import { Stack, Typography, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const Container = muiStyled(Stack)({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '0px 1.6rem',
});
export const Title = muiStyled(Typography)({
  fontSize: '1.4rem',
  lineHeight: '1.6rem',
  letterSpacing: '0.014rem',
});

export const DateText = muiStyled(Typography)({
  color: abyssColors.primary[300],
  fontSize: '1.2rem',
  lineHeight: '1.6rem',
  letterSpacing: '0.012rem',
  marginTop: '0.8rem',
  marginBottom: '1.2rem',
});
